var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoElementalWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 184.877,
    height: 45,
    viewBox: "0 0 184.877 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2061",
    "data-name": "Rect\\xE1ngulo 2061",
    width: 184.877,
    height: 45,
    fill: "#FFFFFF"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "elemental-logo",
    transform: "translate(-876 -26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3746",
    "data-name": "Grupo 3746",
    transform: "translate(876 26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2729",
    "data-name": "Trazado 2729",
    d: "M60.352,78.028,61.4,80.423H59.3Zm-.311-.558-1.989,4.436h.6l.432-.975h2.534l.437.975h.6l-1.99-4.436Z",
    transform: "translate(-30.844 -36.982)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2058",
    "data-name": "Rect\\xE1ngulo 2058",
    width: 0.52,
    height: 4.436,
    transform: "translate(38.695 40.488)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3745",
    "data-name": "Grupo 3745"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3744",
    "data-name": "Grupo 3744",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2730",
    "data-name": "Trazado 2730",
    d: "M84.363,77.874a.377.377,0,0,1-.754-.007.377.377,0,0,1,.754.007m-.671,4.5h.572V78.908h-.572Z",
    transform: "translate(-40.411 -37.457)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2731",
    "data-name": "Trazado 2731",
    d: "M95.208,83.668l-.014-.628a1.46,1.46,0,0,1-1.271.7,1.8,1.8,0,0,1,.007-3.591,1.447,1.447,0,0,1,1.279.685l.007-.629h.559v3.45h-.551ZM93.95,80.692a1.261,1.261,0,0,0,0,2.522,1.265,1.265,0,0,0,.007-2.529Z",
    transform: "translate(-44.542 -38.738)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2732",
    "data-name": "Trazado 2732",
    d: "M106.867,80.2h.524l.027.552a1.412,1.412,0,0,1,1.181-.6,1.465,1.465,0,0,1,1.515,1.6v1.907h-.573v-1.9a.98.98,0,0,0-1.048-1.076,1.071,1.071,0,0,0-1.061,1.124v1.851h-.566V80.2Z",
    transform: "translate(-51.653 -38.738)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2733",
    "data-name": "Trazado 2733",
    d: "M122.967,80.256v.258l-1.942,2.64h1.942v.552h-2.794v-.224l1.956-2.7h-1.837v-.524Z",
    transform: "translate(-58.084 -38.79)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2734",
    "data-name": "Trazado 2734",
    d: "M135.314,83.668l-.014-.628a1.46,1.46,0,0,1-1.271.7,1.8,1.8,0,0,1,.007-3.591,1.447,1.447,0,0,1,1.279.685l.007-.629h.559v3.45h-.551Zm-1.258-2.975a1.261,1.261,0,0,0,0,2.522,1.265,1.265,0,0,0,.007-2.529Z",
    transform: "translate(-63.926 -38.738)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2059",
    "data-name": "Rect\\xE1ngulo 2059",
    width: 0.608,
    height: 4.89,
    transform: "translate(80.785 40.027)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2735",
    "data-name": "Trazado 2735",
    d: "M165.4,80.2h.524l.027.552a1.412,1.412,0,0,1,1.181-.6,1.465,1.465,0,0,1,1.515,1.6v1.907h-.573v-1.9a.98.98,0,0,0-1.048-1.076,1.071,1.071,0,0,0-1.061,1.124v1.851H165.4V80.2Z",
    transform: "translate(-79.946 -38.738)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2736",
    "data-name": "Trazado 2736",
    d: "M179.312,80.211h.531l.035.5a1.107,1.107,0,0,1,1.02-.566,1.152,1.152,0,0,1,1.159.754,1.291,1.291,0,0,1,1.216-.754,1.385,1.385,0,0,1,1.453,1.537v1.97h-.573v-1.97a.9.9,0,0,0-.894-1,.948.948,0,0,0-.943,1.013v1.956h-.572V81.7a.933.933,0,0,0-.929-1.013.943.943,0,0,0-.936,1.013v1.956H179.3V80.2Z",
    transform: "translate(-86.664 -38.738)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2737",
    "data-name": "Trazado 2737",
    d: "M198.78,80.107a1.8,1.8,0,1,1-1.788,1.809,1.724,1.724,0,0,1,1.788-1.809m.007.524a1.2,1.2,0,0,0-1.222,1.285,1.223,1.223,0,1,0,2.445,0,1.21,1.21,0,0,0-1.222-1.285",
    transform: "translate(-95.213 -38.718)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2738",
    "data-name": "Trazado 2738",
    d: "M211.763,79.539a1.456,1.456,0,0,1,1.293-.692,1.789,1.789,0,0,1-.007,3.576,1.453,1.453,0,0,1-1.286-.691l-.027.629h-.545v-4.89h.572Zm.028,1.09a1.2,1.2,0,0,0,1.222,1.257,1.251,1.251,0,0,0,0-2.5,1.2,1.2,0,0,0-1.222,1.244",
    transform: "translate(-102.076 -37.444)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2739",
    "data-name": "Trazado 2739",
    d: "M226.076,77.874a.377.377,0,0,1-.754-.007.377.377,0,0,1,.754.007m-.671,4.5h.572V78.908h-.572Z",
    transform: "translate(-108.906 -37.457)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2060",
    "data-name": "Rect\\xE1ngulo 2060",
    width: 0.573,
    height: 4.89,
    transform: "translate(121.09 40.027)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2740",
    "data-name": "Trazado 2740",
    d: "M243.858,77.874a.377.377,0,0,1-.754-.007.377.377,0,0,1,.754.007m-.671,4.5h.572V78.908h-.572Z",
    transform: "translate(-117.501 -37.457)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2741",
    "data-name": "Trazado 2741",
    d: "M254.7,83.668l-.014-.628a1.46,1.46,0,0,1-1.271.7,1.8,1.8,0,0,1,.007-3.591,1.447,1.447,0,0,1,1.279.685l.007-.629h.559v3.45h-.551Zm-1.258-2.975a1.261,1.261,0,0,0,0,2.522,1.265,1.265,0,0,0,.007-2.529Z",
    transform: "translate(-121.631 -38.738)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2742",
    "data-name": "Trazado 2742",
    d: "M266.9,80.19l.042.517A1.12,1.12,0,0,1,268,80.134a1.3,1.3,0,0,1,.8.259l-.259.489a1.022,1.022,0,0,0-1.614.845v1.92h-.572V80.2h.531Z",
    transform: "translate(-128.742 -38.731)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2743",
    "data-name": "Trazado 2743",
    d: "M278.408,77.874a.377.377,0,0,1-.754-.007.377.377,0,0,1,.754.007m-.671,4.5h.572V78.908h-.572Z",
    transform: "translate(-134.2 -37.457)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2744",
    "data-name": "Trazado 2744",
    d: "M289.252,83.668l-.014-.628a1.46,1.46,0,0,1-1.271.7,1.8,1.8,0,0,1,.007-3.591,1.448,1.448,0,0,1,1.279.685l.007-.629h.559v3.45h-.551Zm-1.258-2.975a1.261,1.261,0,0,0,0,2.522A1.265,1.265,0,0,0,288,80.685Z",
    transform: "translate(-138.33 -38.738)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2745",
    "data-name": "Trazado 2745",
    d: "M332.72,31.331c2.283-.489,2.767-1.059,2.767-3.341q0-11.6,0-23.2c0-2.455-.4-2.911-2.649-3.211L342.624,0V1.3q0,13.322,0,26.646c0,2.442.342,2.856,3.068,3.384Z",
    transform: "translate(-160.815 0)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2746",
    "data-name": "Trazado 2746",
    d: "M30.749,1.574,40.3.033V1.466q0,13.258,0,26.516c0,2.276.451,2.821,3.046,3.357H30.709c.591-.318,1.569-.546,2-1.159a4.575,4.575,0,0,0,.523-2.5c.037-7.513.022-15.026.021-22.539,0-2.807-.166-3.018-2.507-3.569",
    transform: "translate(-14.843 -0.016)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2747",
    "data-name": "Trazado 2747",
    d: "M272.543,15.326l-1.884-.2c-.016-.1-.031-.208-.046-.311l1.931-.356c0-1.135-.063-2.357.038-3.566.03-.365.488-.968.789-.993a12.242,12.242,0,0,0,6.26-2.361v7.033h5.508c.009.16.018.319.027.479h-5.4c-.065.615-.131.948-.131,1.281-.007,4.375-.014,8.75.006,13.125a9.129,9.129,0,0,0,.23,1.966c.53,2.333,2.25,3.126,4.393,2.026.643-.33,1.231-.763,1.885-1.052a8.892,8.892,0,0,1-8.459,3.019c-3.308-.483-4.9-2.1-5.041-5.433-.187-4.278-.085-8.569-.106-12.855,0-.568,0-1.137,0-1.8",
    transform: "translate(-130.797 -3.644)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2748",
    "data-name": "Trazado 2748",
    d: "M116.34,21.5c2.163-3.868,7.922-4.259,10.869-2.049,1.589,1.193,1.967,2.968,1.974,4.839.014,4.106,0,8.212.006,12.318,0,2.514.333,2.924,3.052,3.483H119.492c.631-.328,1.668-.545,2.088-1.174a5.139,5.139,0,0,0,.444-2.644c.041-3.841-.136-7.69.064-11.521.175-3.371-1.89-5.507-5.748-3.252",
    transform: "translate(-56.231 -8.749)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2749",
    "data-name": "Trazado 2749",
    d: "M147.1,40.037c2.268-.482,2.756-1.064,2.756-3.358,0-4.2.041-8.4-.018-12.6-.042-2.983-1.958-4.3-4.521-3.221-.3.128-.606.262-1.041.45,1.321-2.42,4.545-3.705,7.559-3.142,3.6.673,5.126,2.526,5.157,6.379.034,4.067.007,8.133.009,12.2,0,2.311.336,2.73,2.916,3.29Z",
    transform: "translate(-69.736 -8.718)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2750",
    "data-name": "Trazado 2750",
    d: "M236.4,21.234c1.393-2.226,5.26-3.633,8.242-3.033,3.463.7,5.018,2.532,5.041,6.044.026,4.152.007,8.3.009,12.457,0,2.285.47,2.849,2.7,3.342H240.16c.573-.316,1.547-.552,1.965-1.166a4.79,4.79,0,0,0,.486-2.514c.046-3.754.026-7.51.018-11.265-.009-4.228-1.933-5.508-5.838-3.9a1.38,1.38,0,0,1-.388.031",
    transform: "translate(-114.262 -8.73)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2751",
    "data-name": "Trazado 2751",
    d: "M188.766,18.441a3.45,3.45,0,0,0-2.34,2.859c-.681,4.072-1.087,8.194-.02,12.225,1.348,5.1,5.623,6.825,10.322,4.387.583-.3,1.137-.664,1.7-1-1.416,3.019-7.88,4.724-12.457,3.287-5.088-1.6-8.234-6.984-7.368-12.615.814-5.3,5.276-9.364,10.159-9.145",
    transform: "translate(-86.258 -8.909)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2752",
    "data-name": "Trazado 2752",
    d: "M71.21,18.325c-2.618.887-2.9,2.943-2.967,4.985a83.5,83.5,0,0,0,.037,8.984,6.906,6.906,0,0,0,5.434,6.547c1.755.309,3.791-.232,6.515-1.735-.714,2.319-6.831,4.249-10.776,3.4-6.1-1.312-9.509-6.483-8.678-13.157.622-5,5.428-9.292,10.435-9.025",
    transform: "translate(-29.315 -8.851)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2753",
    "data-name": "Trazado 2753",
    d: "M316.274,47.908c-2.167,2.486-4.818,3.676-8.111,2.875a5.324,5.324,0,0,1-1.335-9.871,15.931,15.931,0,0,1,4.129-1.228,19.06,19.06,0,0,1,3.3-.056,14.688,14.688,0,0,1,2.237.111,15.136,15.136,0,0,0-2.465.4c-2.864.948-4.042,5.666-1.979,7.871.917.98,2.064.817,3.191.423a8.428,8.428,0,0,0,1.029-.52",
    transform: "translate(-146.948 -19.131)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2754",
    "data-name": "Trazado 2754",
    d: "M208.641,27.724H198.507c2.183-.253,4.129-.8,4.629-3.338.571-2.891-.191-4.73-2.4-5.941,1.616-.463,4.451.532,6.049,2.219a6.931,6.931,0,0,1,1.853,7.06",
    transform: "translate(-95.945 -8.86)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2755",
    "data-name": "Trazado 2755",
    d: "M82.2,18.326c4.385-.275,9.465,3.328,8.086,9.364H79.7c3.681-.543,4.764-1.323,5.138-3.538.456-2.708-.324-4.549-2.634-5.826",
    transform: "translate(-38.52 -8.85)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2756",
    "data-name": "Trazado 2756",
    d: "M314.97,18.33c-1.579.746-2.626,1.81-2.463,3.657.137,1.556,1.315,2.051,2.643,2.352a4.757,4.757,0,0,1-5.175,1.869,3.357,3.357,0,0,1-1.452-5.819c1.784-1.733,4.1-1.906,6.448-2.06",
    transform: "translate(-148.557 -8.859)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2757",
    "data-name": "Trazado 2757",
    d: "M12.291,45.594v7.672H.506c5.312-.4,9.544-2.385,11.491-7.836Z",
    transform: "translate(-0.245 -21.958)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2758",
    "data-name": "Trazado 2758",
    d: "M11.228,11.984C9.8,6.511,5.87,4.46.76,4.01H11.584v7.741l-.356.234",
    transform: "translate(-0.367 -1.938)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2759",
    "data-name": "Trazado 2759",
    d: "M0,27.433c3.338-.121,6.293-.8,7.98-4.149l.251.269V31.3c-1.9-3.079-4.978-3.589-8.231-3.87",
    transform: "translate(0 -11.254)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2760",
    "data-name": "Trazado 2760",
    d: "M99.259,54.823a6.252,6.252,0,0,0,.624-.272,14.767,14.767,0,0,0,2.543-1.808q.994-.806,1.909-1.7a9.861,9.861,0,0,0,1.626-1.864c.016-.026.033-.054.048-.082v5.943c0-.04-4.9.073-5.314.086l-1.185.039c-.4.014-.09.006-1.323.035.36-.128.72-.239,1.073-.374",
    transform: "translate(-47.457 -23.728)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2761",
    "data-name": "Trazado 2761",
    d: "M218,54.823a6.247,6.247,0,0,0,.624-.272,14.767,14.767,0,0,0,2.543-1.808q.994-.806,1.909-1.7a9.876,9.876,0,0,0,1.625-1.864c.017-.026.033-.054.048-.082v5.943c0-.04-4.9.073-5.314.086l-1.185.039c-.4.014-.09.006-1.323.035.36-.128.72-.239,1.073-.374",
    transform: "translate(-104.847 -23.728)",
    fill: "#FFFFFF"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoElementalWhite);
export default __webpack_public_path__ + "static/media/logoElementalWhite.da0ab46d6b33dc2e15a78e0c7b396747.svg";
export { ForwardRef as ReactComponent };